// @flow
import { defineStore } from 'pinia'
import { pointerType } from '@/utils/device'

export const useUserAuthStore = defineStore('userAuth', {
  state: (): UserAuthState => ({
    // user data
    user:
      Laravel && Laravel.user
        ? Laravel.user
        : { displayName: 'Guest', username: 'guest', isLoggedIn: false },
    settings: Laravel && Laravel.settings ? Laravel.settings : {},
    consents: Laravel && Laravel.consents ? Laravel.consents : {},
    planPurchases: Laravel && Laravel.planPurchases ? Laravel.planPurchases : {},
    csrfToken: Laravel && Laravel.csrfToken ? Laravel.csrfToken : '',

    // ads free video player IDs, set from ssr
    videoPlayer: Laravel && Laravel.videoPlayer ? Laravel.videoPlayer : {},

    // feature flags
    features: Laravel && Laravel.features ? Laravel.features : {},

    // user's device settings
    device: {
      pointerType: pointerType(),
    },

    // hacky way to refresh tag data on the following tag components
    // - user-tag-search
    // - mod-menu-tags
    // - manage-tags
    //
    // each component has a slightly different tag query so not caching
    // tag data in store, but do have a need to reload the tags
    // across components
    refreshTagsInstances: false,

    // cdn prefixes, set from ssr _head.blade.php
    // doesn't really belong to userAuth at all, but didn't want to spin
    // up a separate store just for these read-only values
    // cdn prefixes from window.Laravel
    cdn: Laravel && Laravel.cdn ? Laravel.cdn : {},
  }),

  getters: {
    isUserFbAdmin: (state: UserAuthState): boolean => {
      return !!(state.user && [2, 3, 7].includes(state.user.role))
    },

    completeEffectsEnabled: (state: UserAuthState): boolean => {
      return state.user.completeEffects !== 0
    },

    confettiEnabled: (state: UserAuthState): boolean => {
      return state.user.completeEffects === 1
    },

    isPlanPurchased:
      (state: UserAuthState) =>
      (planId: number): boolean => {
        return !!state.planPurchases[planId]
      },
  },

  actions: {
    updateCsrfToken(newToken: string) {
      this.csrfToken = newToken
    },

    updateDevice(device: DeviceObj) {
      this.device = {
        ...this.device,
        ...device,
      }
    },

    updateUser(newUser: User) {
      this.user = {
        ...this.user,
        ...newUser,
      }
    },

    // previously called setUserLoggedOut
    logoutUser() {
      this.user = {
        isLoggedIn: false,
        displayName: 'Guest',
        firstName: 'guest',
        username: 'guest',
        avatar: '',
        notificationUnreadCount: 0,
        startMonday: 0,
      }
    },

    updateSettings(newSettings: UserSettings) {
      this.settings = {
        ...this.settings,
        ...newSettings,
      }
    },

    updateConsents(newConsents: UserConsents) {
      this.consents = {
        ...this.consents,
        ...newConsents,
      }
    },

    setRefreshTagsInstances(refresh: boolean) {
      this.refreshTagsInstances = refresh
    },
  },
})
